import axios from 'axios';
import apiConfig from '../api.config';

export default function addHotelsRequest(data) {
  const {
    host,
    URIs: { hotels },
  } = apiConfig;

  const uri = `${host}${hotels}`;

  return axios
    .post(uri, JSON.stringify(data), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
